module.exports = __webpack_public_path__ + "img/menuapps.14e977eb.svg";